module.exports = __webpack_public_path__ + "static/advanced features-extract-ad0879099388c5c3c57ac42e6e0828f7.png";